import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  private isLoggedIn(): boolean {
    // return !!localStorage.getItem('token') && !!localStorage.getItem('user');
    return !!localStorage.getItem('user');
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const loggedIn = this.isLoggedIn();
    const goingToLogin = state.url.includes('/login');

    // 🔒 Login page ko block karo agar already logged in ho
    if (loggedIn && goingToLogin) {
      return this.router.createUrlTree(['/platform-legal-organizer']); 
    }

    // 🔒 Protected page ko block karo agar logged in nahi ho
    if (!loggedIn && !goingToLogin) {
      return this.router.createUrlTree(['/login']);
    }

    return true; // ✅ allowed
  }
  
}
